export const TimeKeepingVI = {
    "timeSheet": "Chấm công",
    "shiftSchedule": "Bảng phân ca",
    "shiftRegistrationTable":"Bảng đăng ký ca",
    "shiftAssignment": "Phân ca làm việc",
    "meals": "Bảng chấm công ăn",
    "leaveManagement": "Quản lý ngày nghỉ",
    "autoInout": "Tự động chấm công",
    "casualAndCompensatory": "Quản lý phép, bù",
    "casualLeave": "Quản lý phép",
    "compensatoryLeave": "Quản lý nghỉ bù",

    keyword : {
        "POS_TONG_DT_GOP_CTY": "Tổng doanh thu gộp của công ty",
        "POS_TONG_DT_THUAN_CTY": "Tổng doanh thu thuần của công ty",
        "POS_TONG_LN_GOP_CTY": "Tổng lợi nhuận gộp của công ty",
        "POS_TONG_DT_GOP_NV": "Tổng doanh thu gộp của nhân viên",
        "POS_TONG_DT_THUAN_NV": "Tổng doanh thu thuần của nhân viên",
        "POS_TONG_TIEN_HOA_HONG_NV": "Tổng tiền hoa hồng của nhân viên",
        "POS_TONG_SO_SP_BAN_RA_NV": "Tổng số sản phẩm bán ra",
        "POS_TONG_SO_SP_HOAN_THANH_NV": "Tổng số sản phẩm đã hoàn thành",
        "POS_TONG_SO_DH_BAN_RA_NV": "Tổng số đơn hàng bán ra",
        "POS_TONG_SO_DH_HOAN_THANH_NV": "Tổng số đơn hàng hoàn thành",
        "POS_TONG_SO_KH_MOI_NV": "Tổng số khách hàng mới",
        "POS_TONG_SO_KH_MOI_HOAN_THANH_NV": "Tổng số khách hàng mới hoàn thành",
        "POS_SALE_PLAN_ACHIEVEMENT": "Tỷ lệ hoàn thành Sale Plan",

        "currentYear" : " với năm hiện tại",
        "currentMonth" : " với tháng hiện tại",
        "currentQuarter" : " với quý hiện tại",

        "doWork_task_completed": "Tổng số công việc hoàn thành",
        "doWork_task_late": "Tổng số công việc trễ hạn (gồm cả chưa hoàn thành và hoàn thành)",
        "doWork_task_ontime": "Tổng số công việc hoàn thành đúng hạn",
        "doWork_task_early": "Tổng số công việc hoàn thành vượt tiến độ",
        "doWork_task_pending": "Tổng số công việc chưa xong (chưa hoàn thành và chưa thực hiện)",
        "doWork_task_in_progress": "Số lượng công việc đang thực hiện nhưng chưa hoàn thành",
        "doWork_task_in_overdue_incomplete": "Số lượng công việc quá hạn nhưng chưa hoàn thành",
        "doWork_product_target": "Mục tiêu số lượng sản phẩm cần hoàn thành (khoán ban đầu)",
        "doWork_product_quantity": "Tổng số lượng sản phẩm hoàn thành công việc",
        "doWork_product_remaining": "Số lượng sản phẩm còn lại (không hoàn thành)",

        "totalTaskLabel" : "Tổng số công việc của nhãn {{name}}",
        "totalTaskLabelAndStatus" : "Tổng số công việc của nhãn {{name}} trạng thái {{status}}",

        "UNION": "Kinh phí công đoàn",
        "NUMBER_RELATION": "Số người phụ thuộc",
        "GROSS_INCOME": "Tổng thu nhập",
        "ASSESSABLE_INCOME": "Thu nhập chịu thuế",
        "TAXABLE_INCOME": "Thu nhập tính thuế",
        "PIT": "Thuế thu nhập cá nhân",
        "UNION_EMPLOYER": "Kinh phí công đoàn của người sử dụng lao động",
        "DEDUCT_INSURANCE": "Khấu trừ BHXH, BHYT, BHTN",
        "KPI_MONTH": "Điểm KPI tháng",
        "SALARY_END": "Tổng tiền",
        "SALARY_ENTERPRISE": "Lương chuyển qua TK doanh nghiệp",
        "SALARY_PRIVATE": "Lương chuyển qua TK cá nhân",
        "SALARY_PAID": "Lương đã chi trả",
        "SALARY_REST": "Lương chưa thanh toán",

// SHIFTS

    "THU_TRONG_TUAN_NOTE": "Thứ của ngày đang tính toán",
    "THU_TRONG_TUAN": "Thứ trong tuần",
    "NGAY_NGHI_LE_EXAMPLE": "0|1",
    "NGAY_NGHI_LE_NOTE": "Trả lại 1 nếu ca rơi vào ngày nghỉ lễ , 0 nếu ngược lại",
    "NGAY_NGHI_LE": "Ngày nghỉ lễ",
    "NGAY_NGHI_TUAN_EXAMPLE": "0|1",
    "NGAY_NGHI_TUAN_NOTE": "Trả về 1 nếu ca rơi váo ngày nghỉ tuần , 0 nếu ngược lại",
    "NGAY_NGHI_TUAN": "Ngày nghỉ trong tuần",
    "CA_CHINH_EXAMPLE": "0|1",
    "CA_CHINH_NOTE": "Trả lại 1 nếu ca là ca chính ( không phải ca làm thêm từ đơn , 0 ngược lại)",
    "CA_CHINH": "Ca chính hay không",
    "CA_TU_DONG_EXAMPLE": "0|1",
    "CA_TU_DONG_NOTE": "Trả lại 1 nếu ca là ca tự động phân , 0 nếu ngược lại",
    "CA_TU_DONG": "Ca phần mềm tự động nhận hay không",
    "CHAM_CONG_TRUC_TIEP_NGAY_EXAMPLE": "0|1",
    "CHAM_CONG_TRUC_TIEP_NGAY_NOTE": "Trả lại 1 nếu chấm công là trực tiếp không qua tính toán , o nếu ngược lại của ngày hôm đó",
    "CHAM_CONG_TRUC_TIEP_NGAY": "Chấm công trực tiếp theo ngày",
    "CA_QUA_NGAY_EXAMPLE": "0|1",
    "CA_QUA_NGAY_NOTE": "Trả lại 1 nếu ca là ca ngày , 0 nêu ngược lại",
    "CA_QUA_NGAY": "Ca qua ngày",
    "CA_TU_DONG_CHAM_CONG_EXAMPLE": "0|1",
    "CA_TU_DONG_CHAM_CONG_NOTE": "Trả lại 1 nếu ca là ca tự dộng chấm công , 0 nếu ngược lại",
    "CA_TU_DONG_CHAM_CONG": "Ca phần mềm tự động chấm công",
    "CA_TU_DONG_CHECKOUT_EXAMPLE": "0|1",
    "CA_TU_DONG_CHECKOUT_NOTE": "Trả lại 1 nếu ca tự động checkout , 0 nếu ngược lại",
    "CA_TU_DONG_CHECKOUT": "Ca phần mềm tự động checkout",
    "CA_BAT_BUOC_CHOT_GIUA_CA_EXAMPLE": "0|1",
    "CA_BAT_BUOC_CHOT_GIUA_CA_NOTE": "Trả lại 1 nếu ca là ca bắc buộc chôts giữa ca , 0 nếu ngược lại",
    "CA_BAT_BUOC_CHOT_GIUA_CA": "Ca phần  mềm bắt buộc chốt giữ ca",
    "CA_ID_EXAMPLE": "1",
    "CA_ID_NOTE": "Trả lại ID ca",
    "CA_ID": "ID ca",
    "CA_MA_EXAMPLE": "HC1",
    "CA_MA_NOTE": "Trả lại mã ca",
    "CA_MA": "Mã ca",
    "CA_TEN_EXAMPLE": "Hành chính 1",
    "CA_TEN_NOTE": "Trả lại tên ca",
    "CA_TEN": "Tên ca",
    "NGAY": "Ngày phân ca",
    "THOI_GIAN_BAT_DAU_CA": "Ngày giờ bắt đầu ca làm việc",
    "THOI_GIAN_KET_THUC_CA": "Ngày giờ kết thúc ca làm việc",
    "GIO_BAT_DAU_CA": "Ngày giờ bắt đầu ca làm việc",
    "GIO_KET_THUC_CA": "Ngày giờ kết thúc ca làm việc",
    "GIO_BAT_DAU_NGHI": "GIờ bắt đầu nghỉ",
    "GIO_KET_THUC_NGHI_EXAMPLE": "10/09/2021",
    "GIO_KET_THUC_NGHI": "Giờ kết thúc nghỉ",
    "TONG_SO_GIO_CA_EXAMPLE": "7.5h",
    "TONG_SO_GIO_CA_NOTE": "Trả lại tổng số giờ làm việc của ca",
    "TONG_SO_GIO_CA": "Tổng giờ làm của ca",
    "TONG_SO_CONG_CA_EXAMPLE": "0.5",
    "TONG_SO_CONG_CA_NOTE": "Tổng số công làm việc của ca",
    "TONG_SO_CONG_CA": "Tổng số công của ca làm việc",
    "GIO_LAM_VIEC_THUC_TE_EXAMPLE": "0.6",
    "GIO_LAM_VIEC_THUC_TE_NOTE": "Số giờ làm việc thực tế tính trong ngày",
    "GIO_LAM_VIEC_THUC_TE": "Số giờ đã làm việc thực tế trong ngày",
    "GIO_LAM_VIEC_GIUA_CA_EXAMPLE": "0.7",
    "GIO_LAM_VIEC_GIUA_CA_NOTE": "Số giờ làm việc được tính khi làm việc vào giờ nghỉ giữa ca",
    "GIO_LAM_VIEC_GIUA_CA": "Số giờ đã làm việc trong giờ nghỉ giữa ca",
    "GIO_LAM_VIEC_DEM_EXAMPLE": "0.8",
    "GIO_LAM_VIEC_DEM_NOTE": "Số giờ làm việc thực tế ban đếm ( tính đối với ca đêm)",
    "GIO_LAM_VIEC_DEM": "Số giờ đã làm việc thực tế ban đêm",
    "GIO_LAM_VIEC_NGAY_EXAMPLE": "0.9",
    "GIO_LAM_VIEC_NGAY_NOTE": "Số giờ làm việc thực tế ban ngày ( tính đối với ca ngày)",
    "GIO_LAM_VIEC_NGAY": "Số giờ đã làm việc thực tế ban ngày",
    "SO_GIO_LAM_VIEC_EXAMPLE": "0.1",
    "SO_GIO_LAM_VIEC_NOTE": "Số giờ làm việc tính trong ngày",
    "SO_GIO_LAM_VIEC": "Số giờ đã làm việc trong ca",
    "SO_CONG_LAM_VIEC_EXAMPLE": "0.11",
    "SO_CONG_LAM_VIEC_NOTE": "Số công làm việc tính trong ngày",
    "SO_CONG_LAM_VIEC": "Số công làm việc đã làm trong ca",
    "SO_GIO_NGHI_BU_EXAMPLE": "0.12",
    "SO_GIO_NGHI_BU_NOTE": "Số giờ tính nghỉ bù trong ca",
    "SO_GIO_NGHI_BU": "Số giờ tính nghỉ bù trong ca",
    "SO_GIO_TINH_DON_CHE_DO_EXAMPLE": "0.13",
    "SO_GIO_TINH_DON_CHE_DO_NOTE": "Số giờ được tính của đơn chế độ trong ca",
    "SO_GIO_TINH_DON_CHE_DO": "Số giờ được tính  của đơn chế độ trong ca",
    "CHECKIN_EXAMPLE": "2022-05-09 07:30:00",
    "CHECKIN_NOTE": "Trả lại thời gian định dạng ngày giờ phút giây check in trong ca",
    "CHECKIN": "Thời gian check in trong ca",
    "CHECKOUT_EXAMPLE": "2022-05-09 17:35:00",
    "CHECKOUT_NOTE": "Trả lại thời gian định dạng ngày giờ phút giây check out trong ca",
    "CHECKOUT": "Thời gian check out trong ca",
    "GIO_CHECKIN_EXAMPLE": "07:30:00",
    "GIO_CHECKIN_NOTE": "Trả lại thời gian định dạng giờ phút giây check in trong ca",
    "GIO_CHECKIN": "Giờ check in trong ca",
    "GIO_CHECKOUT_EXAMPLE": "17:35:00",
    "GIO_CHECKOUT_NOTE": "Trả lại thời gian định dạng giờ phút giây check out trong ca",
    "GIO_CHECKOUT": "Giờ check out trong ca",
    "SO_GIO_VANG_MAT": "Số giờ vắng mặt không lương",
    "SO_PHUT_DI_MUON_EXAMPLE": "30",
    "SO_PHUT_DI_MUON_NOTE": "Số phút đi muộn trong ngày",
    "SO_PHUT_DI_MUON": "Số phút đi muộn",
    "SO_PHUT_VE_SOM_EXAMPLE": "‘20",
    "SO_PHUT_VE_SOM_NOTE": "Số ngày về sớm trong ngày",
    "SO_PHUT_VE_SOM": "Số phút về sớm",
    "SO_NGAY_NGHI_EXAMPLE": "0.5",
    "SO_NGAY_NGHI_NOTE": "Số ngày xin nghỉ trong ca",
    "SO_NGAY_NGHI": "Số ngày nghỉ",
    "GHI_CHU_NOTE": "Ghi chú trong ca",
    "GHI_CHU": "Ghi chú",
    "SO_NGAY_NGHI_PHEP_EXAMPLE": "0.5",
    "SO_NGAY_NGHI_PHEP_NOTE": "Số ngày nghỉ phép",
    "SO_NGAY_NGHI_PHEP": "Số ngày nghỉ phép",
    "SO_NGAY_NGHI_KHONG_LY_DO_EXAMPLE": "0.5",
    "SO_NGAY_NGHI_KHONG_LY_DO_NOTE": "Số ngày nghỉ làm không lý do",
    "SO_NGAY_NGHI_KHONG_LY_DO": "Số ngày nghỉ không lý do",
    "KHONG_CHECKIN_EXAMPLE": "0|1",
    "KHONG_CHECKIN_NOTE": "Trả lại 1 nếu quên chốt đến , 0 nếu ngược lại",
    "KHONG_CHECKIN": "Không có chốt đến",
    "KHONG_CHECKOUT_EXAMPLE": "0|1",
    "KHONG_CHECKOUT_NOTE": "Trả lại 1 nếu quên chốt về , 0 nếu ngược lại",
    "KHONG_CHECKOUT": "Không có chốt về",
    "KHONG_CHECKINOUT_EXAMPLE": "0|1",
    "KHONG_CHECKINOUT_NOTE": "Trả lại 1neeus quên chốt đến hoặc chốt về , 0 nếu ngược lại",
    "KHONG_CHECKINOUT": "Không có chốt",
    "NGAY_CONG_TAC": "Có đơn công tác",
    "KY_HIEU_NGHI_EXAMPLE": "1",
    "KY_HIEU_NGHI_NOTE": "Ký hiệu các đơn xin nghỉ , phân tách bởi dấu ,",
    "KY_HIEU_NGHI": "Ký hiệu nghỉ",
    "DU_LIEU_NGHI_EXAMPLE": "1",
    "DU_LIEU_NGHI_NOTE": "{P:1,N:1}",
    "DU_LIEU_NGHI": "Dữ liệu nghỉ",
    "NGUON_CHOT_VAN_TAY_EXAMPLE": "NO_FINGER",
    "NGUON_CHOT_VAN_TAY_NOTE": "NO_FINGER : quên chốt , FAIL_MACHINE : máy chấm công hỏng , MISSION : lý do làm việc ngoài , công tác",
    "NGUON_CHOT_VAN_TAY": "Nguồn chốt vân tay",
    "SO_LAN_QUEN_CHAM_CONG_EXAMPLE": "1",
    "SO_LAN_QUEN_CHAM_CONG_NOTE": "Trả lại số lần quên chốt trong ca",
    "SO_LAN_QUEN_CHAM_CONG": "Số lần quên chốt vân tay",
    "PHEP_SO_GIO_TINH_CONG_EXAMPLE": "3.5",
    "PHEP_SO_GIO_TINH_CONG_NOTE": "Tổng số giờ được chấm công của các đơn xin nghỉ trong ca làm việc",
    "PHEP_SO_GIO_TINH_CONG": "Số giờ được tính công của đơn xin nghỉ",
    "PHEP_SO_CONG_TINH_CONG_EXAMPLE": "3.5",
    "PHEP_SO_CONG_TINH_CONG": "Số công được tính của đơn xin nghỉ",
    "PHEP_SO_GIO_KHONG_TINH_CONG_EXAMPLE": "4",
    "PHEP_SO_GIO_KHONG_TINH_CONG_NOTE": "Tổng số giờ không được chấm công của các đơn xin nghỉ trong ca làm việc",
    "PHEP_SO_GIO_KHONG_TINH_CONG": "Số giờ không được tính công của đơn xin nghỉ",
    "PHEP_SO_CONG_KHONG_TINH_CONG_EXAMPLE": "4",
    "PHEP_SO_CONG_KHONG_TINH_CONG": "Số công không được tính công của đơn xin nghỉ",
    "CONG_TAM_UNG_EXAMPLE": "1",
    "CONG_TAM_UNG_NOTE": "Trả lại số công tạm ứng",
    "CONG_TAM_UNG": "Số công tạm ứng",
    "LOAI_HOP_DONG_ID_EXAMPLE": "1",
    "LOAI_HOP_DONG_ID": "ID loại hợp đồng",
    "LOAI_HOP_DONG_EXAMPLE": "THOIHAN",
    "LOAI_HOP_DONG_NOTE": "Loại hợp đồng của nhân sự . Bao gồm : 0,1",
    "LOAI_HOP_DONG": "Loại hợp đồng",
    "CONG_LAM_VIEC_EXAMPLE": "1",
    "CONG_LAM_VIEC_NOTE": "Công thức tính công cho ca làm việc",
    "CONG_LAM_VIEC": "Công làm việc",
    "GIO_LAM_VIEC_NOTE": "Giờ làm việc thực tính",
    "GIO_LAM_VIEC": "GIờ làm việc thực tính",
    "CONG_AN_NOTE": "Công thức tính công ăn của ca",
    "CONG_AN": "Công ăn",
    "TIEN_PHAT_DI_MUON_EXAMPLE": "1",
    "TIEN_PHAT_DI_MUON_NOTE": "Công thức tính tiền phạt đi muộn",
    "TIEN_PHAT_DI_MUON": "TIền phạt đi muộn",
    "TIEN_PHAT_VE_SOM_EXAMPLE": "1",
    "TIEN_PHAT_VE_SOM_NOTE": "Công thức tính tiền phạt về sớm",
    "TIEN_PHAT_VE_SOM": "TIền phạt về sớm",
    "TIEN_PHAT_NGHI_KHONG_LY_DO_EXAMPLE": "1",
    "TIEN_PHAT_NGHI_KHONG_LY_DO_NOTE": "Công thức tính tiền phạt nghỉ không lý do",
    "TIEN_PHAT_NGHI_KHONG_LY_DO": "TIền phạt nghỉ không lý do",
    "TIEN_PHAT_KHONG_CHECKINOUT_EXAMPLE": "1",
    "TIEN_PHAT_KHONG_CHECKINOUT_NOTE": "Công thức tính tiền quên checkinout",
    "TIEN_PHAT_KHONG_CHECKINOUT": "Tiền phạt quên check inout",
    "CONG_PHAT_DI_MUON": "Công phạt đi muộn",
    "CONG_PHAT_VE_SOM": "Công phạt về sớm",
    "CONG_PHAT_NGHI_KHONG_LY_DO": "Công phạt nghỉ không lý do",
    "CONG_PHAT_KHONG_CHECKINOUT": "Công phạt quên check inout",
    "CA_DUOC_PHAN": "Ca được phân",
    "LOAI_CA": "Loại ca được phân ( Hành chính - Ca kíp )",
    "DONG_TANG_CA": "Đơn tăng ca",
    "CHI_TIET_DON_TANG_CA": "Chi tiết đơn tăng ca",
    "LOAI_TINH_CONG": "Tăng ca tính nghỉ bù hoặc tính công",

// #DATES

        "NGAY_EXAMPLE": "10/09/2021",
        "NGAY_NOTE": "Ngày đang tính toán",
        "TRANG_THAI_LAM_VIEC_EXAMPLE": "WORKING",
        "TRANG_THAI_LAM_VIEC_NOTE": "Trả về trạng thái làm việc trong ngày của nhân sự đó . WORKING = đang làm việc . LEAVING = nghỉ thai sản . STOP_WORKING = Nghỉ việc",
        "TRANG_THAI_LAM_VIEC": "Trạng thái làm việc",
        "CHAM_CONG_TRUC_TIEP_EXAMPLE": "0|1",
        "CHAM_CONG_TRUC_TIEP_NOTE": "Trả về 1 nếu chấm công là trực tiếp không qua tính toán , 0 nếu ngươc lại",
        "CHAM_CONG_TRUC_TIEP": "Chấm công trực tiếp",
        "SO_LAN_DI_MUON_NOTE": "Số lần đi muộn trong ngày",
        "SO_LAN_DI_MUON": "Số lần đi muộn trong ngày",
        "SO_LAN_VE_SOM_NOTE": "Số lần về sơm trong ngày",
        "SO_LAN_VE_SOM": "Số lần về sớm trong ngày",
        "NGAY_NGHI_BU_SU_KIEN_EXAMPLE": "01",
        "NGAY_NGHI_BU_SU_KIEN_NOTE": "Trả lại 1 nếu có nghỉ bù , nghỉ sự kiện , 0 nếu không nghỉ",
        "NGAY_NGHI_BU_SU_KIEN": "Ngày nghỉ bù , nghỉ sự kiện",
        "NGAY_CONG_TAC_EXAMPLE": "0|1",
        "GIO_CONG_TAC_EXAMPLE": "0|8",
        "GIO_CONG_TAC": "Giờ làm việc của ngày công tác",
        "PHU_PHI_CONG_TAC_EXAMPLE": "100000",
        "PHU_PHI_CONG_TAC": "Phụ phí công tác",
        "TONG_SO_CA_EXAMPLE": "1",
        "TONG_SO_CA_NOTE": "Tổng số ca làm việc trong ngày",
        "TONG_SO_CA": "Số ca",
        "SO_CONG_NGHI_LE_NOTE": "Số công được hưởng vào ngày nghỉ lễ , nghỉ bù hoặc sự kiện",
        "SO_CONG_NGHI_LE": "Số công được tính khi nghỉ lễ",
        "SO_GIO_NGHI_LE_NOTE": "Số giờ được hưởng vào ngày nghỉ lễ , nghỉ bù hoặc sự kiện",
        "SO_GIO_NGHI_LE": "Số giờ được tính khi nghỉ lễ",
        "NGAY_KHONG_LAM_VIEC_EXAMPLE": "0|1",
        "NGAY_KHONG_LAM_VIEC_NOTE": "Trả lại 0 nếu là ngày làm việc ( được phân ca , nghỉ tuần hoặc lễ ) , 1 nếu ngược lại",
        "NGAY_KHONG_LAM_VIEC": "Ngày không làm việc",
        "CONG_LAM_VIEC_CA": "Công của ca làm việc",
        "GIO_LAM_VIEC_CA": "Giờ làm việc thực tính của ca",
        "CONG_NGHI_LE": "Công của ngày nghỉ lễ",
        "GIO_NGHI_LE": "GIờ làm việc của ngày nghỉ lễ",
        "CONG_AN_THEM": "Công ăn thêm trong ngày",
        "CONG_LAM_THEM": "Công làm thêm trong ngày",
        "CONG_LAM_THEM_THUC_TE": "Công làm thêm trong ngày thực tế",
        "GIO_LAM_THEM": "Giờ làm thêm trong ngày",
        "GIO_LAM_THEM_THUC_TE": "Giờ làm thêm thực tế",
        "CONG_LAM_THEM_DEM_NOTE": "Công thực tính công cho giờ làm thêm ban đêm",
        "CONG_LAM_THEM_DEM": "Công làm thêm ban đêm",
        "CONG_LAM_THEM_THUC_TE_DEM_NOTE": "Công thực tính công ban đêm cho làm thêm thực tế",
        "CONG_LAM_THEM_THUC_TE_DEM": "Công làm thêm thực tế ban đêm",
        "GIO_LAM_THEM_DEM": "Giờ làm thêm ban đêm",
        "GIO_LAM_THEM_THUC_TE_DEM": "GIờ làm thêm thực tế ban đêm",
        "GIO_LAM_THEM_NGAY_NGHI_LE": "Giờ làm thêm trong ngày lễ",
        "GIO_LAM_THEM_NGAY_NGHI_TUAN": "Giờ làm thêm trong ngày nghỉ tuần",
        "GIO_LAM_THEM_NGAY_DI_LAM": "Giờ làm thêm trong ngày đi làm",
        "CONG_CONG_TAC": "Công công tác trong ngày",
        "GHI_CHU_NGAY_NOTE": "Ghi chú bảng chấm công theo ngày",
        "GHI_CHU_NGAY": "Ghi chú",
        "NGAY_LAM_THEM_HOM_TRUOC_EXAMPLE": "0|1",
        "NGAY_LAM_THEM_HOM_TRUOC_NOTE": "0 : trả về ngày hôm trước không làm thêm , 1 là ngày hôm trước có làm thêm",
        "NGAY_LAM_THEM_HOM_TRUOC": "Làm thêm ngày hôm trước",
        "NGAY_DI_LAM_EXAMPLE": "1|0",
        "NGAY_DI_LAM_NOTE": "1 là ngày đó có đi làm , 0 là nghỉ , nghỉ tuần , nghỉ phép , nghỉ lễ",
        "NGAY_DI_LAM": "Ngày đi làm hay không",
        "CONG_THUC_TE_EXAMPLE": "1",
        "CONG_THUC_TE_NOTE": "Trả về số công thực tế đi làm , không tính công của đơn từ",
        "CONG_THUC_TE": "Công thực tế đi làm",
        "CHOT_DAU_TIEN_NOTE": "Chốt đầu tiên",
        "CHOT_DAU_TIEN": "Chốt đầu tiên",
        "CHOT_CUOI_CUNG_NOTE": "Chốt cuối cùng",
        "CHOT_CUOI_CUNG": "Chốt cuối cùng",

        //Overtimes

        "DEM_EXAMPLE": "0|1",
        "DEM": "Làm đêm",
        "THU_TRONG_TUAN_EXAMPLE": "2,3,4,5,6,7,8",
        "NGAY_LAM_THEM_HOM_TRUOC_LOAI_EXAMPLE": "NORMAL|HOLIDAY|DAYOFF",
        "NGAY_LAM_THEM_HOM_TRUOC_LOAI_NOTE": "NORMAL là ngày đi làm , DAYOFF là ngày nghỉ , HOLIDAY là ngày nghỉ lễ",
        "NGAY_LAM_THEM_HOM_TRUOC_LOAI": "Ngày trước là ngày thường , hay ngày lễ",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_BAT_DAU_EXAMPLE": "17:30",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_BAT_DAU": "Thời gian gian bắt đầu làm thêm hôm trước",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_KET_THUC_EXAMPLE": "19:30",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_KET_THUC": "Thời gian kết thúc làm thêm hôm trước",
        "GIO_LAM_BU_THUC_TE_NOTE": "Giờ làm bù thực tính",
        "GIO_LAM_BU_THUC_TE": "Giờ làm bù thực tính",
        "GIO_LAM_THEM_ID": "ID bản ghi giờ làm thêm",

        //Month

        "ID_EXAMPLE": "99",
        "ID_NOTE": "Trả lại ID hệ thống của nhân sự",
        "ID": "ID",
        "MA_NHAN_SU_EXAMPLE": "1234",
        "MA_NHAN_SU_NOTE": "Trả lại mã hồ sơ của nhân sự",
        "MA_NHAN_SU": "Mã nhân sự",
        "HO_TEN_EXAMPLE": "Nguyễn văn A",
        "HO_TEN_NOTE": "Trả lại tên của nhân sự",
        "HO_TEN": "Họ và tên",
        "MA_HOP_DONG_EXAMPLE": "1368_01",
        "MA_HOP_DONG_NOTE": "Trả lại mã hợp đồng của nhân sự",
        "MA_HOP_DONG": "Mã hợp đồng",
        "MA_CHAM_CONG_EXAMPLE": "1234",
        "MA_CHAM_CONG_NOTE": "TRả lại code chấm công hệ thống của nhân sự",
        "MA_CHAM_CONG": "Code",
        "SO_BHXH_EXAMPLE": "1221",
        "SO_BHXH_NOTE": "Trả lại số sổ bảo hiểm của nhân sự",
        "SO_BHXH": "Số sổ bảo hiểm",
        "SO_THE_BHYT_EXAMPLE": "835323….",
        "SO_THE_BHYT_NOTE": "Trả lại số thẻ bảo hiểm y tế của nhân sự",
        "SO_THE_BHYT": "Số thẻ bảo hiểm y tế",
        "VI_TRI_EXAMPLE": "Nhân viên cửa hàng",
        "VI_TRI_NOTE": "Trả lại tên vị trí của nhân sự",
        "VI_TRI": "Vị trí",
        "SO_NGUOI_PHU_THUOC_EXAMPLE": "2",
        "SO_NGUOI_PHU_THUOC_NOTE": "Trả lại số người phụ thuộc",
        "SO_NGUOI_PHU_THUOC": "Số người phụ thuộc",
        "VI_TRI_ID_NOTE": "Trả lại id vị trí của nhân sự",
        "VI_TRI_ID": "ID vị trí",
        "CHUC_VU_EXAMPLE": "Giám đốc kinh doanh",
        "CHUC_VU_NOTE": "Trả lại tên chức danh của nhân sự",
        "CHUC_VU": "Chức vụ",
        "CHUC_DANH_ID_NOTE": "Trả lại id chức danh của nhân sự",
        "CHUC_DANH_ID": "ID chức vụ",
        "MA_PHONG_BAN_EXAMPLE": "PB01",
        "MA_PHONG_BAN_NOTE": "Mã phòng ban của nhân sự",
        "MA_PHONG_BAN": "Mã phòng ban",
        "TEN_PHONG_BAN_EXAMPLE": "Kinh doanh 2",
        "TEN_PHONG_BAN_NOTE": "Tên phòng ban của nhân sự",
        "TEN_PHONG_BAN": "Tên phòng ban",
        "TEN_PHONG_BAN_DAY_DU_EXAMPLE": "Công ty A/Kinh doanh 2",
        "TEN_PHONG_BAN_DAY_DU_NOTE": "Tên phòng ban đầy đủ của nhân sự",
        "TEN_PHONG_BAN_DAY_DU": "Tên phòng ban đầy đủ",
        "TEN_PHONG_BAN_CHINH_EXAMPLE": "Kinh doanh 2",
        "TEN_PHONG_BAN_CHINH_NOTE": "Tên phòng ban chính của nhân sự",
        "TEN_PHONG_BAN_CHINH": "Tên phòng ban chính",
        "PHONG_BAN_ID_EXAMPLE": "KInh doanh 2",
        "PHONG_BAN_ID_NOTE": "ID hệ thống phòng ban của nhân sự",
        "PHONG_BAN_ID": "ID phòng ban",
        "CHI_NHANH_ID_EXAMPLE": "CHi nhánh 1",
        "CHI_NHANH_ID_NOTE": "ID hệ thống chi nhánh của nhân sự",
        "CHI_NHANH_ID": "ID chi nhánh",
        "CHI_NHANH_TEN_EXAMPLE": "Chi nhánh 1",
        "CHI_NHANH_TEN_NOTE": "Tên chi nhánh của nhân sự",
        "CHI_NHANH_TEN": "Tên chi nhánh",
        "CONG_TY_ID_EXAMPLE": "Công ty",
        "CONG_TY_ID_NOTE": "ID công ty của nhân sự",
        "CONG_TY_ID": "ID công ty",
        "CONG_TY_TEN_EXAMPLE": "Công ty",
        "CONG_TY_TEN_NOTE": "Tên công ty của nhân sự",
        "CONG_TY_TEN": "Tên công ty",
        "NGAY_NGHI_VIEC_NOTE": "Ngày nghỉ việc của nhân sự",
        "NGAY_NGHI_VIEC": "Ngày nghỉ việc",
        "GIOI_TINH_EXAMPLE": "Nam|Nữ|Khác",
        "GIOI_TINH_NOTE": "Giới tính của nhân sự",
        "GIOI_TINH": "GIới tính",
        "EMAIL_NOTE": "Email của nhân sự",
        "EMAIL": "Email",
        "NGAY_SINH_NOTE": "Ngày sinh của nhân sự",
        "NGAY_SINH": "Ngày sinh",
        "DIEN_THOAI_NOTE": "Số điện thoại của nhân sự",
        "DIEN_THOAI": "Số điện thoại",
        "QUOC_TICH_NOTE": "Quốc tịch của nhân sự",
        "QUOC_TICH": "Quốc tịch",
        "TEN_TAI_KHOAN_NGAN_HANG_NOTE": "Tên tài khoản ngân hàng của nhân sự",
        "TEN_TAI_KHOAN_NGAN_HANG": "Tên tài khoản ngân hàng",
        "MA_SO_THUE_CA_NHAN_NOTE": "Mã số thuế cá nhân của nhân sự",
        "MA_SO_THUE_CA_NHAN": "Mã số thuế cá nhân",
        "SO_TAI_KHOAN_NGAN_HANG_NOTE": "Số tài khoản ngân hàng của nhân sự",
        "SO_TAI_KHOAN_NGAN_HANG": "Số tài khoản ngân hàng",
        "TEN_NGAN_HANG_NOTE": "Tên ngân hàng của nhân sự",
        "TEN_NGAN_HANG": "Tên ngân hàng",
        "TEN_NGAN_HANG_QUOC_TE_NOTE": "Tên quốc tế của ngân hàng của nhân sự",
        "TEN_NGAN_HANG_QUOC_TE": "Tên quốc tế của ngân hàng",
        "NGAN_HANG_ID_NOTE": "Trả lại id ngân hàng của nhân sự",
        "NGAN_HANG_ID": "ID ngân hàng",
        "NGAN_HANG_CODE_NOTE": "Mã ngân hàng của nhân sự",
        "NGAN_HANG_CODE": "Mã ngân hàng",
        "NGAN_HANG_CHI_NHANH_NOTE": "Tên chi nhánh ngân hàng của nhân sự",
        "NGAN_HANG_CHI_NHANH": "Chi nhánh ngân hàng",
        "NOI_LAM_VIEC_EXAMPLE": "0|1",
        "NOI_LAM_VIEC_NOTE": "Nơi làm việc của nhân sự",
        "NOI_LAM_VIEC": "Nơi làm việc",
        "KHONG_YEU_CAU_CHOT_CONG_EXAMPLE": "0|1",
        "KHONG_YEU_CAU_CHOT_CONG_NOTE": "Trả lại 1 nếu không bắt buộc chốt vân tay , 0 nếu ngược lại",
        "KHONG_YEU_CAU_CHOT_CONG": "Không cần chốt vân tay",
        "SO_CONG_CHUAN_TU_DONG_EXAMPLE": "23",
        "SO_CONG_CHUAN_TU_DONG_NOTE": "Trả lại số công chuẩn của nhân sự theo vị trí",
        "SO_CONG_CHUAN_TU_DONG": "Số công chuẩn tự động tính theo công thức cài đặt",
        "SO_CONG_CHUAN_EXAMPLE": "5000000",
        "SO_CONG_CHUAN_NOTE": "Trả lại số công chuẩn theo công thức cài đặt",
        "SO_CONG_CHUAN": "Số công chuẩn tính theo công thức chỉnh sửa",
        "LUONG_VI_TRI_EXAMPLE": "3210000",
        "LUONG_VI_TRI_NOTE": "Trả lại lương vị trí của nhân sự",
        "LUONG_VI_TRI": "Lương vị trí",
        "LUONG_BHXH_NOTE": "Trả lại lương đóng bảo hiểm của nhân sự",
        "LUONG_BHXH": "Lương đóng bảo hiểm",
        "LUONG_PHU_CAP_NOTE": "Trả lại lương phụ cấp của nhân sự",
        "LUONG_PHU_CAP": "Lương phụ cấp",
        "LUONG_PHU_CAP_TINH_THUE_EXAMPLE": "11000000",
        "LUONG_PHU_CAP_TINH_THUE_NOTE": "Trả lại lương phụ cấp tính thuế của nhân sự",
        "LUONG_PHU_CAP_TINH_THUE": "Lương phụ cấp tính thuế",
        "LUONG_PHU_CAP_KHONG_TINH_THUE_EXAMPLE": "4400000",
        "LUONG_PHU_CAP_KHONG_TINH_THUE_NOTE": "Trả lại lương phụ cấp không tính thuế của nhân sự",
        "LUONG_PHU_CAP_KHONG_TINH_THUE": "Lương phụ cấp không tính thuế",
        "GIAM_TRU_CA_NHAN_NOTE": "Trả lại mức giảm trừ cá nhân của nhân sự",
        "GIAM_TRU_CA_NHAN": "Mức giảm trừ cá nhân",
        "GIAM_THUE_1_NGUOI_PHU_THUOC_NOTE": "Trả lại mức miễn giảm thuế với 1 người phụ thuộc",
        "GIAM_THUE_1_NGUOI_PHU_THUOC": "Mức miễn giảm thuế với 1 người phụ thuộc",
        "NGAY_VAO_NOTE": "Trả lại ngày vào công ty",
        "NGAY_VAO": "Ngày vào công ty",
        "NGAY_VAO_CHINH_THUC_NOTE": "Trả lại ngày vào chính thức công ty",
        "NGAY_VAO_CHINH_THUC": "Ngày vào chính thức công ty",
        "TEN_HOP_DONG_EXAMPLE": "Hợp đồng lao động 6 tháng",
        "TEN_HOP_DONG_NOTE": "Tên loại hợp đồng",
        "TEN_HOP_DONG": "Tên hợp đồng",
        "GIO_LAM_VIEC_TRONG_NGAY_EXAMPLE": "835323….",
        "GIO_LAM_VIEC_TRONG_NGAY_NOTE": "Số giờ làm việc của nhân sự trong một ngày",
        "GIO_LAM_VIEC_TRONG_NGAY": "GIờ làm việc/ngày theo vị trí",
        "GIO_LAM_VIEC_TRONG_TUAN_EXAMPLE": "40",
        "GIO_LAM_VIEC_TRONG_TUAN_NOTE": "Số giờ làm việc của nhân sự trong một tuần",
        "GIO_LAM_VIEC_TRONG_TUAN": "Giờ làm việc/tuần theo vị trí",
        "BLOCK_CONG_EXAMPLE": "0.5",
        "BLOCK_CONG_NOTE": "Đơn vị block của tính công",
        "BLOCK_CONG": "Block công",
        "THANG_EXAMPLE": "10",
        "THANG_NOTE": "Tháng đang xét",
        "THANG": "Tháng",
        "NAM_EXAMPLE": "2022",
        "NAM_NOTE": "Năm đang xét",
        "NAM": "Năm",
        "NGAY_BAT_DAU_EXAMPLE": "10/09/2021",
        "NGAY_BAT_DAU_NOTE": "Ngày bắt đầu tính công trong tháng",
        "NGAY_BAT_DAU": "Ngày bắt đầu",
        "NGAY_KET_THUC_EXAMPLE": "10/10/2021",
        "NGAY_KET_THUC_NOTE": "Ngày kết thúc tính công",
        "NGAY_KET_THUC": "Ngày kết thúc",
        "TONG_SO_NGAY_EXAMPLE": "31",
        "TONG_SO_NGAY_NOTE": "Tổng số ngày thực tế",
        "TONG_SO_NGAY": "Tổng số ngày",
        "TONG_SO_NGAY_CHU_NHAT_EXAMPLE": "3",
        "TONG_SO_NGAY_CHU_NHAT_NOTE": "Tổng số ngày chủ nhật trong tháng",
        "TONG_SO_NGAY_CHU_NHAT": "Tổng số ngày chủ nhật",
        "TONG_SO_NGAY_T2_EXAMPLE": "3",
        "TONG_SO_NGAY_T2_NOTE": "Tổng số ngày thứ 2 trong tháng",
        "TONG_SO_NGAY_T2": "Tổng số ngày thứ hai",
        "TONG_SO_NGAY_T3_EXAMPLE": "3",
        "TONG_SO_NGAY_T3_NOTE": "Tổng số ngày thứ 3 trong tháng",
        "TONG_SO_NGAY_T3": "Tổng số ngày thứ ba",
        "TONG_SO_NGAY_T4_EXAMPLE": "3",
        "TONG_SO_NGAY_T4_NOTE": "Tổng số ngày thứ 4 trong tháng",
        "TONG_SO_NGAY_T4": "Tổng số ngày thứ tư",
        "TONG_SO_NGAY_T5_EXAMPLE": "3",
        "TONG_SO_NGAY_T5_NOTE": "Tổng số ngày thứ 5 trong tháng",
        "TONG_SO_NGAY_T5": "Tổng số ngày thứ năm",
        "TONG_SO_NGAY_T6_EXAMPLE": "3",
        "TONG_SO_NGAY_T6_NOTE": "Tổng số ngày thứ 6 trong tháng",
        "TONG_SO_NGAY_T6": "Tổng số ngày thứ sáu",
        "TONG_SO_NGAY_T7_CHAN_EXAMPLE": "3",
        "TONG_SO_NGAY_T7_CHAN_NOTE": "Tổng số ngày thứ 7 tuần lẻ trong tháng",
        "TONG_SO_NGAY_T7_CHAN": "Tổng số ngày thứ bảy tuần lẻ",
        "TONG_SO_NGAY_T7_LE_EXAMPLE": "3",
        "TONG_SO_NGAY_T7_LE_NOTE": "Tổng số ngày thứ 7 tuần chẵn trong tháng",
        "TONG_SO_NGAY_T7_LE": "Tổng số ngày thứ bảy tuần chẵn",
        "TONG_SO_TUAN_DAY_DU_EXAMPLE": "2",
        "TONG_SO_TUAN_DAY_DU_NOTE": "Tổng số tuần nguyên ( đầy đủ thứ của tuần ) trong tháng",
        "TONG_SO_TUAN_DAY_DU": "Tổng số tuần nguyên",
        "TONG_SO_GIO_LAM_VIEC_EXAMPLE": "0.5",
        "TONG_SO_GIO_LAM_VIEC_NOTE": "Tổng số giờ làm việc do hệ thống tính",
        "TONG_SO_GIO_LAM_VIEC": "Tổng số giờ làm việc",
        "SO_GIO_LAM_VIEC_CA_NOTE": "Giờ  làm việc theo ca",
        "SO_GIO_LAM_VIEC_CA": "GIờ làm việc theo ca",
        "TONG_SO_GIO_LAM_VIEC_CA_EXAMPLE": "23",
        "TONG_SO_GIO_LAM_VIEC_CA_NOTE": "Tổng sô giờ làm việc theo ca",
        "TONG_SO_GIO_LAM_VIEC_CA": "Tổng số giờ làm việc theo ca",
        "CONG_LAM_VIEC_CA_NOTE": "Công thức tính công cho ca làm việc",
        "CONG_LE": "Công lễ",
        "TONG_GIO_LAM_VIEC_EXAMPLE": "23",
        "TONG_GIO_LAM_VIEC_NOTE": "Tổng số giờ làm việc thực tính của nhân sự trong tháng . Trường hợp nhân sự tách dòng chấm công thì nó là tổng của các dòng tách",
        "TONG_GIO_LAM_VIEC": "Tổng giờ làm việc thực tính",
        "CONG_LAM_THEM_NOTE": "Công thức tính công cho giờ làm thêm",
        "CONG_LAM_THEM_THUC_TE_NOTE": "Công thức tính công cho giờ làm thêm thực tế",
        "CONG_AN_CA_NOTE": "Công ăn theo ca trong tháng",
        "CONG_AN_CA": "Công ăn theo ca",
        "TIEN_PHAT_CHAM_CONG_NOTE": "Công thức tính tiền phạt đi muộn",
        "TIEN_PHAT_CHAM_CONG": "TIền phạt chấm công",
        "TIEN_KHEN_THUONG_EXAMPLE": "10000000",
        "TIEN_KHEN_THUONG_NOTE": "Số tiền mà nhân viên được khen thưởng",
        "TIEN_KHEN_THUONG": "TIền khen thưởng",
        "TIEN_VI_PHAM_EXAMPLE": "1000000",
        "TIEN_VI_PHAM_NOTE": "Số tiền mà nhân viên vi phạm trong tháng",
        "TIEN_VI_PHAM": "TIền vi phạm",
        "TIEN_PHUC_LOI_EXAMPLE": "1000000",
        "TIEN_PHUC_LOI_NOTE": "Số tiền phúc lợi trong tháng",
        "TIEN_PHUC_LOI": "Tiền phúc lợi",
        "PHEP_DAU_KY_NOTE": "Số phép đầu kì",
        "PHEP_DAU_KY": "Số phép đầu kì",
        "PHEP_DA_DUNG_NOTE": "Số phép đã dùng",
        "PHEP_DA_DUNG": "Số phép đã dùng",
        "PHEP_CUOI_KY_NOTE": "Số phép cuối kì",
        "PHEP_CUOI_KY": "Số phép cuối kỳ",
        "NGHI_BU_DAU_KY_NOTE": "Số nghỉ bù đầu kì",
        "NGHI_BU_DAU_KY": "Số nghỉ bù đầu kì",
        "NGHI_BU_DA_DUNG_NOTE": "Số nghỉ bù đã dùng",
        "NGHI_BU_DA_DUNG": "Số nghỉ bù đã dùng",
        "NGHI_BU_GIO_THEM_NOTE": "Số nghỉ bù giờ thêm",
        "NGHI_BU_GIO_THEM": "Số nghỉ bù giờ thêm",
        "NGHI_BU_CUOI_KY_NOTE": "Số nghỉ bù cuối kỳ",
        "NGHI_BU_CUOI_KY": "Số nghỉ bù cuối kỳ",

        //mission

        "DIA_DIEM": "Địa điểm",
        "TIEN_PHU_PHI": "TIền phụ phí",
        "SO_GIO": "Số giờ",
        "CONG_TAC_NUOC_NGOAI_EXAMPLE": "0|1",
        "CONG_TAC_NUOC_NGOAI_NOTE": "Trả lại 1 là nước ngoài , 0 là trong nước",
        "CONG_TAC_NUOC_NGOAI": "Trạng thái công tác nước ngoài",
        "LY_DO_CONG_TAC_NOTE": "Lý do chi tiết về công tác trong nước hoặc nước ngoài",
        "LY_DO_CONG_TAC": "Lý do công tác nước ngoài",

        // absence
        "TU_NGAY": "Từ ngày",
        "DEN_NGAY": "Đến ngày",
        "TU_GIO": "Từ giờ",
        "DEN_GIO": "Đến giờ",
        "GIO_VANG_MAT_NOTE": "Đã trừ đi giờ nghỉ , khoảng nghỉ bất thường",
        "GIO_VANG_MAT": "Số giờ vắng mặt",
        "NGAY_VANG_MAT": "Ngày vắng mặt",
        "LY_DO_BI_PHAT_NOTE": "Lý do vắng có bị phạt hay không",
        "LY_DO_BI_PHAT": "Lý do bị phạt",
        "LY_DO_VANG_MAT": "Lý do vắng mặt",
        "TINH_LUONG_NOTE": "Trả lại 0 hoặc 1",
        "TINH_LUONG": "Được tính lương",

        //check-in

        "THOI_GIAN_CHAM_CONG": "Thời gian chốt",
        "LOAI_CHAM_CONG_EXAMPLE": "MACHINE|APP|GPS",
        "LOAI_CHAM_CONG_NOTE": "MACHINE : chốt từ máy chấm công , APP : chốt ghi nhận từ đơn được duyệt , GPS : chốt ghi nhận từ điện thoại",
        "LOAI_CHAM_CONG": "Loại chốt",
        "LY_DO_EXAMPLE": "NO_FINGER|FAIL_MACHINE|MISSION",
        "LY_DO_NOTE": "NO_FINGER : quên chốt , FAIL_MACHINE : máy chấm công hỏng , MISSION : lý do làm việc ngoài , công tác",
        "LY_DO": "Lý do",
        "DIA_CHI_EXAMPLE": "Trụ sở công ty , công trường",
        "DIA_CHI": "Địa chỉ",
        "MAY_CHAM_CONG_ID": "Mã máy chấm công"

    }
}